export default {
  // 过滤掉字符串中的_BRIDAL
  filterBridal (val) {
    if (val.includes('BRIDAL')) {
      val = val.replace('_BRIDAL', '')
    }
    return val
  }
}
